async function createCustomerAccessToken(email, password) {
  let storefrontToken = document.getElementById('storefront-access-token')?.value;
  let storefrontEndpoint = document.getElementById('storefront-endpoint')?.value;

  // Fallback to localStorage if not found
  if (!storefrontToken) {
    storefrontToken = localStorage.getItem('storefrontToken');
  }
  if (!storefrontEndpoint) {
    storefrontEndpoint = localStorage.getItem('storefrontEndpoint');
  }

  if (!storefrontToken || !storefrontEndpoint) {
    console.error('Token o endpoint Storefront mancante');
    return { success: false, error: 'Missing storefront configuration' };
  }

  // Save to localStorage for future use
  localStorage.setItem('storefrontToken', storefrontToken);
  localStorage.setItem('storefrontEndpoint', storefrontEndpoint);

  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    input: { email, password }
  };

  try {
    const response = await fetch(storefrontEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({ query, variables })
    });

    const result = await response.json();
    const data = result?.data?.customerAccessTokenCreate;

    if (data?.customerAccessToken?.accessToken) {
      const token = data.customerAccessToken.accessToken;
      // Save token and onboarding flag in sessionStorage (per-session scope)
      try {
        sessionStorage.setItem('customerAccessToken', token);
        localStorage.setItem('is-account-new', 'true');
      } catch (err) {
        // Fallback to localStorage if sessionStorage is unavailable (e.g., strict privacy settings)
        console.warn('sessionStorage unavailable, falling back to localStorage:', err);
        localStorage.setItem('customerAccessToken', token);
        localStorage.setItem('is-account-new', 'true');
      }
      return { success: true, token };
    }

    console.warn('[DEBUG] Errore nella creazione del token:', data?.customerUserErrors);
    return { success: false, errors: data?.customerUserErrors || [] };
  } catch (error) {
    console.error('[DEBUG] Errore nella richiesta GraphQL:', error);
    return { success: false, error };
  }
}

window.FGAuth = {
  createCustomerAccessToken
};
